import { QuotaPayload } from '../../shared/interfaces/quota.interface';
import {
  Qualification,
  SelectedQuota,
} from '../../shared/interfaces/qualification.interface';

export class AssignQuota {
  constructor(private readonly _quotas: QuotaPayload[]) {}

  public to(qualifications: Qualification[]): Qualification[] {
    this._quotas.forEach((quota) => {
      const qualification = this._find(quota, qualifications);

      if (qualification) {
        qualification.quotas?.push(quota as SelectedQuota);
        qualification.flexible = quota.flexible;
      }
    });

    return [...qualifications];
  }

  private _find(quota: QuotaPayload, qualifications: Qualification[]) {
    return qualifications.find(
      (q) => q.qualification_code === quota.criteria[0].qualification_code
    );
  }
}
